var React = require('react');

function ErrorInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.30899 1.682L0.108991 15.8C-0.200009 16.332 0.183991 17 0.799991 17H17.2C17.816 17 18.2 16.332 17.891 15.8L9.69099 1.682C9.38299 1.151 8.61699 1.151 8.30899 1.682Z","fill":"#A8000B","key":0}),React.createElement("path",{"d":"M9.89999 5H8.09999V11H9.89999V5Z","fill":"white","key":1}),React.createElement("path",{"d":"M8.99998 14.826C9.69034 14.826 10.25 14.2663 10.25 13.576C10.25 12.8856 9.69034 12.326 8.99998 12.326C8.30963 12.326 7.74998 12.8856 7.74998 13.576C7.74998 14.2663 8.30963 14.826 8.99998 14.826Z","fill":"white","key":2})]);
}

ErrorInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","role":"img","aria-hidden":"true","focusable":"false"};

module.exports = ErrorInline;

ErrorInline.default = ErrorInline;
